import React, { useState, useRef, useEffect, useContext } from "react";
import CryptoJS from "crypto-js";
import { AuthContext } from "../../context/AuthContext";
import { useLocation, useParams, useSearchParams } from "react-router-dom";
const Overview = () => {
  const [candidates, setCandidates] = useState("");
  const [candidatesContacted, setCandidatesContacted] = useState("");
  const [candidatesShortlisted, setCandidatesShortlisted] = useState("");
  const [upcommingInterviews, setInterviewsCount] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();

  const jobDesc_id = searchParams.get("jd_id");
  const job_id = searchParams.get("job_id");
  const { token } = useContext(AuthContext);

  const getResponse = async () => {
    var jd_id = jobDesc_id;
    const encryptedMetadata = localStorage.getItem("metadata");
    // if (encryptedMetadata){
    //     const decryptedMetadata = JSON.parse(CryptoJS.AES.decrypt(encryptedMetadata, process.env.REACT_APP_SECRETKEY).toString(CryptoJS.enc.Utf8));
    //     if(decryptedMetadata.jd_id){
    //         jd_id = decryptedMetadata.jd_id;
    //     }
    // }
    // setJDvalue(jd_id);
    const encryptedData = CryptoJS.AES.encrypt(
      JSON.stringify({ jd_id: jd_id, fromJob: true, job_id: job_id }),
      process.env.REACT_APP_SECRETKEY
    ).toString();
    var searchData = { data: encryptedData };
    console.log(searchData, "searchData");
    setIsLoading(true);
    try {
      const serverURL = process.env.REACT_APP_SERVER_URL;
      const response = await fetch(`${serverURL}/JD/getJdDetail`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          token: token,
        },
        body: JSON.stringify(searchData),
      });
      const result = await response.json();
      console.log("Server Response:", result);
      if (!response.ok) {
        throw new Error(result.error);
      }
      const decryptedData = JSON.parse(
        CryptoJS.AES.decrypt(
          result.data,
          process.env.REACT_APP_SECRETKEY
        ).toString(CryptoJS.enc.Utf8)
      );
      console.log("resumeDetails: ", decryptedData);
      if (decryptedData["message"]) {
        console.log("message:", decryptedData);
        // setProcessingMessage(decryptedData['message'])
        return;
      }
      // console.log("resumeDetails: ",decryptedData[jd_id]["resumedetail"])
      // console.log("fitment_Details: ",decryptedData[jd_id]["fitment"]["resumes"])

      let resumeDet;
      let ctr = 0;
      let contactCount = 0;
      let shortlistCount = 0;
      const recommendedStatus = decryptedData;
      // console.log("resumestatus: ",recommendedStatus);
      Object.keys(recommendedStatus).forEach((resName) => {
        console.log("resName: ", recommendedStatus[resName]["resumedetail"]);
        resumeDet = recommendedStatus[resName]["resumedetail"];
        Object.keys(resumeDet).map((key) => {
          ctr++;
          if (resumeDet[key]["pipeline_type"] === "contact") {
            contactCount++;
          }
          if (resumeDet[key]["pipeline_type"] === "shortlist") {
            shortlistCount++;
          }
          console.log("res pipe status: ", ctr);
        });
      });
      console.log("resumeDetails: ", recommendedStatus);
      let count = 0;
      // Object.keys(decryptedData).map((key,val)=>(
      //   count++,
      //   console.log(count,"Rec")
      // ))

      if (ctr < 1000) {
        setCandidates(ctr);
      }
      if (ctr >= 1000) {
        setCandidates(ctr / 1000 + "k");
      }
      if (contactCount < 1000) {
        setCandidatesContacted(contactCount);
      }
      if (contactCount >= 1000) {
        setCandidatesContacted(contactCount / 1000 + "k");
      }
      if (shortlistCount < 1000) {
        setCandidatesShortlisted(shortlistCount);
      }
      if (shortlistCount >= 1000) {
        setCandidatesShortlisted(shortlistCount / 1000 + "k");
      }

      // setAiSearchResult(decryptedData[jd_id]);
      // setResumeDetails(decryptedData[jd_id]['resumedetail'])

      if (
        decryptedData[jd_id] &&
        decryptedData[jd_id]["fitment"] &&
        decryptedData[jd_id]["fitment"]["resumes"]
      ) {
        //   setFitment(decryptedData[jd_id]["fitment"]["resumes"]);
      }

      // console.log(decryptedData)
      // showNotification(result.message, "success");
    } catch (error) {
      console.error("Error uploading file:", error);
      // showNotification(error.message, "error");
    } finally {
      // setIsLoading(false); // Always hide loader after the request
    }
  };
  const getUpcommingInterviews = async () => {
    // console.log("inside interview get");

    const localMeta = localStorage.getItem("metadata");
    const decryptedLocalMetaData = JSON.parse(
      CryptoJS.AES.decrypt(localMeta, process.env.REACT_APP_SECRETKEY).toString(
        CryptoJS.enc.Utf8
      )
    );
    const cardContent = {
      job_id: job_id,
      type: "upcoming",
      company_id: decryptedLocalMetaData.cid.toString(),
    };
    console.log("Sending Data :: ", cardContent);
    const encryptedDashData = CryptoJS.AES.encrypt(
      JSON.stringify(cardContent),
      process.env.REACT_APP_SECRETKEY
    ).toString();

    console.log("Decrypted local meta :: ", decryptedLocalMetaData);
    try {
      const response = await fetch(
        `${process.env.REACT_APP_SERVER_URL}/calendly/fetchScheduleDetails`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json", token },
          body: JSON.stringify({ data: encryptedDashData }),
        }
      );

      const rawData = await response.text();
      const responsedata = JSON.parse(rawData);
      const decryptedData = responsedata.data;
      setInterviewsCount(decryptedData.length);
      console.log(responsedata, "upcomming interview");
    } catch (error) {
      console.error("Error uploading file:", error);
      // showNotification(error.message, "error");
    }
  };
  useEffect(() => {
    getResponse();
    getUpcommingInterviews();
  }, []);
  return (
    <div className="bg-white w-full max-w-7xl mx-auto p-4 sm:p-6 bg-opacity-50 rounded-xl">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6">
        <div className="bg-[#F2F9F9] rounded-[17px] p-4 sm:p-5 flex flex-col items-center justify-center min-h-[100px]">
          <p className="mb-0 text-2xl sm:text-3xl font-bold text-[#059669] text-center">
            {candidates || 0}
          </p>
          <p className="mb-0 text-xs sm:text-sm font-medium text-[#059669] text-center mt-1">
            Total Resumes
          </p>
        </div>
        <div className="bg-[#F2F9F9] rounded-[17px] p-4 sm:p-5 flex flex-col items-center justify-center min-h-[100px]">
          <p className="mb-0 text-2xl sm:text-3xl font-bold text-[#059669] text-center">
            {upcommingInterviews || 0}
          </p>
          <p className="mb-0 text-xs sm:text-sm font-medium text-[#059669] text-center mt-1">
            Upcoming Interviews
          </p>
        </div>
        <div className="bg-[#F2F9F9] rounded-[17px] p-4 sm:p-5 flex flex-col items-center justify-center min-h-[100px]">
          <p className="mb-0 text-2xl sm:text-3xl font-bold text-[#059669] text-center">
            {candidatesContacted || 0}
          </p>
          <p className="mb-0 text-xs sm:text-sm font-medium text-[#059669] text-center mt-1">
            Candidates Contacted
          </p>
        </div>
        <div className="bg-[#F2F9F9] rounded-[17px] p-4 sm:p-5 flex flex-col items-center justify-center min-h-[100px]">
          <p className="mb-0 text-2xl sm:text-3xl font-bold text-[#059669] text-center">
            {candidatesShortlisted || 0}
          </p>
          <p className="mb-0 text-xs sm:text-sm font-medium text-[#059669] text-center mt-1">
            Candidates Shortlisted
          </p>
        </div>
        {/* <div className="w-[177px] h-[100px] bg-[#F2F9F9] rounded-[17px] relative pt-[14px] pb-[14px] pl-[10px] pr-[10px] grid gap-[4px]">
                            <p className="mb-0 text-[26px] font-[700] mx-auto items-center text-[#059669]">{`1`}</p>
                            <p className="mb-0 text-[11px] font-[500] text-[#059669] mx-auto text-center "></p>
                        </div> */}
      </div>
    </div>
  );
};
export default Overview;
